export interface NotificationDotProps {
  show?: boolean;
  color?: string;
  className?: string;
  children: React.ReactNode;
}

/**
 * Small indicator dot overlay — typically for unread state.
 */
export function NotificationDot({
  show = true,
  color = "bg-red-500",
  className = "",
  children,
}: NotificationDotProps) {
  return (
    <span className={`relative inline-flex ${className}`}>
      {children}
      {show && (
        <span
          className={`absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full ${color} ring-2 ring-bg-card`}
          aria-label="unread"
        />
      )}
    </span>
  );
}
